import styled from '@emotion/styled'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import ButtonText from '@segment/matcha/components/ButtonText'

import Badge from '@segment/matcha/components/Badge'

import CardBase, * as Card from '@segment/matcha/recipes/Card'

import * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

const copy = {
  heading: `Ready to enable customer insights and analytics?`,
  data: [
    {
      tag: `Recipe`,
      title: `Supercharge user profiles with ChatGPT and Twilio Segment: unlocking the power of personalization based on sentiment analysis`,
      buttonText: `Read the recipe`,
      href: `/recipes/personalize-with-chatgpt-and-segment-sentiment-analysis/`,
    },
    {
      tag: `Case study`,
      title: `How global healthcare leader Sanofi uses Twilio Segment to build golden profiles, increase omni-channel engagement, and improve patient outcomes`,
      buttonText: `Read the case study`,
      href: `/customers/sanofi/`,
    },
    {
      tag: `Webinar`,
      title: `No Code Required: CustomerAI Predictions in Action`,
      buttonText: `Watch the webinar`,
      href: `https://webinars.segment.com/segment/no-code-required-customerai-predictions-in-action`,
    },
  ],
}

const GetReady = () => {
  const pageConfig = usePageConfig()
  return (
    <Wrapper>
      <StyledSection variant="centered">
        <Section.Copy>
          <CopyText.Heading variant="h2" tag="h2">
            {copy.heading}
          </CopyText.Heading>
        </Section.Copy>

        <Section.Contents>
          <ColumnTrack columns={1} overrides={{ md: 3 }}>
            {copy.data.map(({ tag, title, buttonText, href }, key) => (
              <CardBase key={key} appearance="twilioLight" href={getAbsoluteUrl(href, pageConfig)}>
                <Card.Body>
                  <Card.Accessories>
                    <Card.AccessoriesRow>
                      <Badge variant="outlined">{tag}</Badge>
                    </Card.AccessoriesRow>
                  </Card.Accessories>
                  <Card.Copy>
                    <Card.Headline tag="h3" variant="h4">
                      {title}
                    </Card.Headline>
                  </Card.Copy>
                  <Card.Action alignment="left">
                    <ButtonText iconEnd={ChevronRightIcon}>{buttonText}</ButtonText>
                  </Card.Action>
                </Card.Body>
              </CardBase>
            ))}
          </ColumnTrack>
        </Section.Contents>
      </StyledSection>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background: ${({ theme }) => theme.palette.twilio.mint[10]};
`

const StyledSection = styled(SectionBase)`
  max-width: 1280px;
`

export default GetReady
